// Generated for @nava/participant-copy: Clair's default texts in Norwegian. Edit the texts here; the
// participant app's locale files are not read at runtime.
/** Clair's default texts in Norwegian. The texts that changed for Clair are translated without native review yet. */
export const PARTICIPANT_COPY_NB = {
    'landing.changeLanguage': 'Bytt språk',
    'common.language': 'Språk',
    // New for Clair, translated without native review yet.
    'common.talkInLanguages': 'Du kan snakke med Clair på mer enn 80 språk.',
    'common.seeLanguages': 'Se hvilke',
    'footer.poweredBy': 'Levert av',
    'landing.heading': 'Du er invitert til en kort samtale.',
    'landing.intro': '{company} vil gjerne høre hvordan det går med deg. Du snakker med Clair, en AI-assistent, når det passer deg.',
    'landing.continue': 'Fortsett',
    'preflight.title': 'Vi trenger bare noen få ting',
    'preflight.checkInSubtitle': 'Gå gjennom listen nedenfor for å starte samtalen.',
    'preflight.actions.expandItem': 'Utvid {{item}}',
    'preflight.microphone.title': 'Mikrofontilgang',
    'preflight.microphone.checkInPrivacy': 'Stemmen din brukes til samtalen med Clair, en AI-assistent. Samtalen tas opp, transkriberes og deles med {company}. All data krypteres og lagres sikkert.',
    'preflight.microphone.readMore': 'Les mer',
    'preflight.microphone.grantAccess': 'Gi tilgang',
    'preflight.microphone.indicatorAction': 'Gi mikrofontilgang',
    'preflight.microphone.accessGranted': 'Tilgang gitt',
    'preflight.microphone.errorHelper': 'Sjekk nettleserinnstillingene dine og prøv igjen.',
    'preflight.microphone.browserNotSupported': 'Nettleseren din støtter ikke lydopptak. Vennligst bruk Chrome, Firefox eller Safari.',
    'preflight.terms.title': 'Personvern og samtykke',
    'preflight.terms.checkInPrivacy': 'Samtalen føres av Clair, en AI-assistent, på vegne av {company}. Svarene dine deles med {company} og brukes aldri til reklame. Du kan stoppe når som helst.',
    'preflight.terms.readMore': 'Les mer',
    'preflight.terms.accept': 'Ja, jeg godtar',
    'preflight.terms.indicatorAction': 'Godta personvern og samtykke',
    'preflight.terms.accepted': 'Godtatt',
    'preflight.terms.rememberConsent': 'Husk samtykket mitt i 30 dager',
    'preflight.terms.rememberConsentCallTooltip': 'Samtykket lagres bare for denne samtalen i denne nettleseren i 30 dager.',
    'quickStart.agree': 'Godta',
    'quickStart.back': 'Tilbake',
    'quickStart.cancel': 'Avbryt',
    'preflight.startCheckIn': 'Start samtalen',
    'preflight.preparingCheckIn': 'Samtalen forberedes...',
    'preflight.preparingCheckInDelayedTitle': 'Samtalen forberedes.',
    'preflight.preparingCheckInDelayedSubtitle': 'Vi jobber fortsatt, vennligst vent.',
    'preflight.preparingCheckInLongSubtitleLineOne': 'Dette tar lengre tid enn forventet.',
    'preflight.preparingCheckInLongSubtitleLineTwo': 'Vær tålmodig.',
    'preflight.checkInPreparationFailedTitle': 'Samtalen kunne ikke forberedes',
    'preflight.checkInPreparationFailedMessage': 'Noen filer til samtalen kunne ikke lastes inn. Sjekk tilkoblingen og prøv igjen.',
    'preflight.retryPreparation': 'Try again',
    'interview.status.connecting': 'Kobler til',
    'interview.status.speaking': 'Snakker',
    'interview.status.listening': 'Lytter',
    'interview.status.thinking': 'Tenker',
    'interview.question': 'Spørsmål {{current}} av {{total}}',
    'interview.mainQuestion': 'Hovedspørsmål {{current}} av {{total}}',
    'interview.recording': 'Svaret ditt blir tatt opp...',
    'interview.endInterview': 'Avslutt samtalen',
    'interview.muteTooltip': 'Demp mikrofon',
    'interview.unmuteTooltip': 'Slå på mikrofon',
    'interview.pauseTooltip': 'Ta en pause',
    'interview.resumeTooltip': 'Gjenoppta samtalen',
    'interview.subtitleTooltip.show': 'Vis undertekster (CC)',
    'interview.subtitleTooltip.hide': 'Skjul undertekster (CC)',
    'interview.toggleChat': 'Skriv i stedet',
    'interview.toggleVoice': 'Snakk i stedet',
    'interview.chatTooltip.type': 'Skriv svaret ditt i stedet',
    'interview.chatTooltip.speak': 'Snakk svaret ditt i stedet',
    'interview.chatTooltip.unavailable': 'Tilgjengelig når tilkoblingen er klar',
    'interview.chatDiscoveryHint': 'Kan du ikke snakke? Trykk for å skrive i stedet',
    'interview.chatPlaceholder': 'Skriv meldingen din...',
    'interview.sendMessage': 'Send',
    'interview.chat.warmHeader': 'Ta deg god tid, jeg venter mens du skriver',
    'interview.chat.newlineHint': 'Shift + Enter for ny linje',
    'interview.chat.aiVoiceOn': 'Stemme på',
    'interview.chat.aiVoiceOff': 'Stemme av',
    'interview.chat.backToVoice': 'Tilbake til stemme',
    'interview.audio.controls': 'Lydinnstillinger',
    'interview.audio.callVolume': 'Samtalevolum',
    'interview.audio.muteSpeaker': 'Slå av høyttalerlyden',
    'interview.audio.unmuteSpeaker': 'Slå på høyttalerlyden',
    'interview.audio.microphone': 'Mikrofon',
    'interview.audio.speaker': 'Høyttaler',
    'interview.audio.device': 'Lydenhet',
    'interview.audio.linkedRouting': 'Telefonen styrer mikrofonen og høyttaleren sammen.',
    'interview.audio.phoneSpeaker': 'Telefonens høyttaler',
    'interview.audio.phoneEarpiece': 'Telefonens øretelefon',
    'interview.audio.bluetoothHeadset': 'Bluetooth-hodesett',
    'interview.audio.wiredHeadset': 'Hodesett med ledning',
    'interview.audio.usbAudio': 'USB-lyd',
    'interview.audio.systemDefault': 'Systemstandard',
    'interview.audio.changeFailed': 'Kunne ikke bytte lydenhet.',
    'interview.networkQuality.excellent': 'Nettverkskvaliteten er utmerket.',
    'interview.networkQuality.good': 'Nettverkskvaliteten er god.',
    'interview.networkQuality.poor': 'Nettverkskvaliteten er dårlig.',
    'interview.networkQuality.bad': 'Nettverkskvaliteten er svært dårlig.',
    'interview.networkQuality.offline': 'Tilkoblingen er frakoblet.',
    'interview.pauseModal.title': 'Samtalen er satt på pause',
    'interview.pauseModal.timeRemaining': '{{time}} igjen',
    'interview.pauseModal.timeoutWarning': 'Hvis du blir værende på pause, avsluttes samtalen snart av seg selv.',
    'interview.pauseModal.resume': 'Gjenoppta samtalen',
    'interview.pauseModal.end': 'Avslutt samtalen',
    'interview.endConfirm.title': 'Avslutte samtalen?',
    'interview.endConfirm.body': 'Du kan ikke gå tilbake etter at du har avsluttet. Svarene dine så langt lagres.',
    'interview.endConfirm.cancel': 'Fortsett samtalen',
    'interview.endConfirm.end': 'Avslutt samtalen',
    'complete.checkInTitle': 'Takk for at du tok deg tid',
    'complete.checkInMessage': 'Svarene dine går til teamet hos {company}.',
    'studyClosed.checkInTitle': 'Denne samtalen er stengt',
    'studyClosed.checkInMessage': 'Takk for interessen, den tar ikke lenger imot svar.',
    'studyNotOpen.checkInTitle': 'Denne samtalen er ikke åpen ennå',
    'studyNotOpen.checkInMessage': 'Prøv gjerne lenken igjen senere.',
    'studyNotReady.checkInTitle': 'Samtalen er nesten klar',
    'studyNotReady.checkInMessage': 'Prøv gjerne lenken igjen om noen minutter.',
    'participantLinkCompleted.checkInTitle': 'Du har allerede hatt denne samtalen',
    'participantLinkCompleted.checkInMessage': 'Takk for at du tok deg tid, du trenger ikke gjøre noe mer.',
    'loading.interview': 'Laster inn samtalen...',
    'browserHelp.title': 'Åpne i nettleseren din',
    'browserHelp.description': 'Appens innebygde nettleser kan begrense tilgangen til mikrofonen. Åpne lenken i {{browserOptions}} for best mulig opplevelse.',
    'browserHelp.namedDescription': 'Den innebygde nettleseren i {{app}} kan begrense tilgangen til mikrofonen. Åpne lenken i {{browserOptions}} for best mulig opplevelse.',
    'browserHelp.appleBrowsers': 'Safari eller Chrome',
    'browserHelp.windowsBrowsers': 'Microsoft Edge eller Chrome',
    'browserHelp.otherBrowsers': 'Chrome eller en annen nettleser',
    'browserHelp.openSafari': 'Åpne i Safari',
    'browserHelp.copyLink': 'Kopier lenke',
    'browserHelp.copied': 'Lenken er kopiert. Lim den inn i nettleseren din.',
    'browserHelp.manualCopy': 'Kunne ikke kopiere automatisk. Marker og kopier lenken nedenfor.',
    'browserHelp.copyInstructions': 'Kopier lenken nedenfor og lim den inn i en annen nettleser. Du kan også se etter et alternativ i appens meny for å åpne siden i standardnettleseren din.',
    'browserHelp.linkLabel': 'Lenke til samtalen',
    'browserHelp.continueAnyway': 'Fortsett likevel',
    'preflight.microphone.recovery.denied': 'Tilgang til mikrofonen ble avslått.',
    'preflight.microphone.recovery.timedOut': 'Forespørselen om mikrofontilgang tok for lang tid. Se etter en tillatelsesforespørsel i nettleseren, og prøv igjen.',
    'preflight.microphone.recovery.notFound': 'Fant ingen mikrofon. Koble til en mikrofon og prøv igjen.',
    'preflight.microphone.recovery.notReadable': 'Mikrofonen kunne ikke åpnes. Lukk andre apper som bruker den, og prøv igjen.',
    'preflight.microphone.recovery.failed': 'Vi fikk ikke tilgang til mikrofonen. Kontroller mikrofonen og prøv igjen.',
    'preflight.microphone.recovery.retry': 'Prøv igjen',
    'preflight.microphone.recovery.close': 'Lukk',
    'preflight.microphone.recovery.helpTitle': 'Tillat mikrofontilgang',
    'preflight.microphone.recovery.helpDescription': 'Tilgang til mikrofonen er fortsatt blokkert. Nettleseren kan ha lagret det tidligere valget ditt og derfor ikke spørre om tillatelse på nytt.',
    'preflight.microphone.recovery.safariMacSettings': 'Velg Safari > Innstillinger > Nettsteder > Mikrofon i menylinjen i Safari. Finn dette nettstedet i listen.',
    'preflight.microphone.recovery.chromiumSettings': 'Klikk på ikonet for nettstedsinnstillinger til venstre for adressefeltet, og velg Nettstedsinnstillinger > Mikrofon.',
    'preflight.microphone.recovery.siteSettings': 'Åpne tillatelsene for dette nettstedet via ikonet eller menyen ved adressefeltet, eller via nettleserens nettstedsinnstillinger.',
    'preflight.microphone.recovery.allowMicrophone': 'Tillat mikrofontilgang for dette nettstedet, gå tilbake hit og velg «Prøv igjen». Last inn siden på nytt hvis nettleseren ber om det.',
    'preflight.microphone.recovery.deviceSettings': 'Hvis tilgang allerede er tillatt, kontroller at enhetsinnstillingene tillater at nettleseren bruker mikrofonen.',
    'microphoneQuality.title': 'Mikrofonkvalitet',
    'microphoneQuality.instructions': 'Snakk i noen sekunder så vi kan sjekke hvor godt vi hører deg.',
    'microphoneQuality.recoveryMessage': 'Vi kan ikke høre deg. Hvis du er i en telefonsamtale, avslutt den først. Lukk andre apper som bruker mikrofonen, og prøv igjen.',
    'microphoneQuality.poor': 'Dårlig',
    'microphoneQuality.almostThere': 'Nesten der',
    'microphoneQuality.perfect': 'Perfekt!',
    'microphoneQuality.waiting': 'Venter på lyd...',
    'microphoneQuality.from': 'Fra',
    'microphoneQuality.defaultDevice': 'Standardmikrofon',
    'microphoneQuality.helpText': 'Vennligst snakk høyere eller flytt deg nærmere mikrofonen',
    'microphoneQuality.done': 'Ferdig',
    'startupRecovery.title': 'Samtalen kunne ikke starte',
    'startupRecovery.failed': 'Vi fikk ikke kontakt med samtaletjenesten. Prøv igjen.',
    'startupRecovery.timedOut': 'Tilkoblingen tok for lang tid. Prøv igjen.',
    'startupRecovery.cancelled': 'Tilkoblingen ble avbrutt. Du kan prøve igjen når du er klar.',
    'startupRecovery.microphone': 'Vi fikk ikke tilgang til mikrofonen. Sjekk tillatelsene og prøv igjen.',
    'startupRecovery.delayed': 'Kobler fortsatt til. Dette tar lengre tid enn vanlig…',
    'startupRecovery.retry': 'Prøv igjen',
    'startupRecovery.support': 'Referanse for brukerstøtte',
    'startupRecovery.copy': 'Kopier referanse',
    'startupRecovery.copied': 'Kopiert',
    'startupRecovery.checking': 'Sjekker tilkoblingen…',
    'startupRecovery.unavailable': 'Kunne ikke bekreftes',
    'startupRecovery.advice': 'Denne sjekken tester bare om tjenestene kan nås. Du kan likevel prøve å starte. Hvis det ikke fungerer, prøv en annen nettleser eller et annet nettverk.',
    'startupRecovery.checkAgain': 'Sjekk tilkoblingen på nytt...',
    'connectionDetails.quality': 'Nettverkskvalitet',
    'connectionDetails.excellent': 'Utmerket',
    'connectionDetails.good': 'God',
    'connectionDetails.poor': 'Svak',
    'connectionDetails.bad': 'Dårlig',
    'connectionDetails.offline': 'Frakoblet',
    'connectionDetails.notChecked': 'Ikke sjekket',
    'connectionDetails.lastChecked': 'Sist sjekket',
    'connectionDetails.warning': 'Kunne ikke bekrefte tilkoblingen til {{services}}.',
    'connectionDetails.navaApi': 'Clairs API',
    'connectionDetails.interviewApi': 'Clairs samtaletjeneste',
    'connectionDetails.ok': 'OK',
    'connectionDetails.refresh': 'Oppdater tilkoblingstest',
    'connectionDetails.success': 'Tilkoblingskontrollen var vellykket.',
    'connection.error': 'Tilkoblingsfeil',
    'connection.errorDefault': 'Kunne ikke koble til samtaletjenesten',
    'connection.retry': 'Prøv igjen',
    'versionRefresh.message': 'En ny versjon er tilgjengelig. Oppdater nettleseren når det passer deg.',
    'versionRefresh.action': 'Oppdater',
    'cookies.banner.title': 'Vi verdsetter personvernet ditt',
    'cookies.banner.message': 'Vi bruker informasjonskapsler for å optimalisere opplevelsen din, forstå produktbruk og støtte relevant markedsføring. Velg <bold>“Godta alle”</bold> for å samtykke til alle informasjonskapsler, eller <bold>“Administrer preferanser”</bold> for å justere innstillingene dine.',
    'cookies.banner.privacyPolicy': 'Personvernerklæring',
    'cookies.banner.acceptAll': 'Godta alle',
    'cookies.banner.managePreferences': 'Administrer preferanser',
    'cookies.modal.title': 'Innstillinger for informasjonskapsler',
    'cookies.modal.description': 'Når du besøker Clair, kan vi lagre eller hente data om deg ved hjelp av informasjonskapsler og lignende teknologi. Nødvendige informasjonskapsler holder nettstedet i gang. Du kan når som helst endre valgfrie innstillinger.',
    'cookies.modal.readMore': 'Les mer i vår',
    'cookies.modal.save': 'Lagre',
    'cookies.modal.close': 'Lukk cookie-innstillinger',
    'cookies.modal.essential.title': 'Nødvendig',
    'cookies.modal.essential.description': 'Påkrevd for grunnleggende funksjonalitet på nettstedet. Nødvendige informasjonskapsler kan ikke deaktiveres.',
    'cookies.modal.analytics.title': 'Analyse',
    'cookies.modal.analytics.description': 'Hjelper Clair med å forstå hvordan nettstedet fungerer, hvordan besøkende bruker det, og om det kan være tekniske problemer.',
    'invitation.subject': 'En kort samtale med {company}',
    'invitation.greeting': 'Hei {name},',
    'invitation.body': 'Vi vil gjerne høre hvordan det går med deg.',
    'invitation.aiNotice': 'Du snakker med Clair, AI-assistenten vår. De fleste synes det er lettere å være ærlig overfor en AI enn overfor et menneske, og du kan gjøre det når det passer deg, på jobb eller hjemme.',
    'invitation.button': 'Start samtalen',
    'invitation.fallbackLink': 'Eller lim inn denne lenken i nettleseren:',
    'invitation.footer': 'Du får denne e-posten fordi du er kunde hos {company}. Samtalen føres av Clair, en AI-assistent, på deres vegne.',
    'invitation.optOut': 'Ikke send dette til meg igjen',
    'sms.invite': '{company} inviterer deg til en kort samtale:',
    'sms.stop': 'Stopp SMS:',
};
//# sourceMappingURL=nb.js.map